require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./leading-the-screensaver-revolution.json") })
        }
      }, "path---leading-the-screensaver-revolution");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---leading-the-screensaver-revolution!./.cache/json/leading-the-screensaver-revolution.json
// module id = 528
// module chunks = 231608221292675